import React from 'react';
import PropTypes from 'prop-types';
import SelectionModel from '../models/SelectionModel'
import {observer} from 'mobx-react';


@observer
export default class DropDown extends React.Component{


  _didSelect(item) {
    this.props.onSelect(item);
  }


    componentDidMount() {

    }

    render() {
        let self= this;
        let styles = this.props.styles || [];
        return (
            <div className={"btn-group " + styles.join(' ')}>
                <button className="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {(self.props.dataProvider.selectedOption)?self.props.dataProvider.selectedOption.title:"Bitte wählen"} <span className="caret"></span>
                </button>
                <ul className="dropdown-menu ">

                  {this.props.dataProvider.options.map(function (option) {
                    return <li key={option.key} onClick={self._didSelect.bind(self,option)}><a >{option.title}</a></li>;
                  })}

                </ul>
            </div>
        );
    }
}

DropDown.propTypes = {

    id: PropTypes.string,
    selectedItem:PropTypes.object,
    dataProvider:PropTypes.instanceOf(SelectionModel).isRequired,
    onSelect:PropTypes.func,
    labelField:PropTypes.string,
    styles:PropTypes.array
};




// WEBPACK FOOTER //
// ./src/components/DropDown.js